import { categoryActions } from "./category/categoryActions";

export const megaActions = {
	category: categoryActions,
};
